module.exports = __webpack_public_path__ + "static/media/Incident History.ff86e8dc.svg";